import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { DuesyPanelComponent } from './duesy-panel/duesy-panel.component';
import { DuesyRobotIconComponent } from './duesy-robot-icon.component';
import { DuesyWidgetComponent } from './duesy-widget/duesy-widget.component';

/** Duesy support assistant: mounted once in AppComponent. */
@NgModule({
  declarations: [DuesyWidgetComponent, DuesyPanelComponent, DuesyRobotIconComponent],
  imports: [CommonModule, FormsModule, MenuModule],
  exports: [DuesyWidgetComponent],
})
export class DuesyModule {}
